import { ModuleWithProviders, NgModule } from '@angular/core';
import { ClientLibComponent } from './client-lib.component';
import { AuditCardComponent } from './components/cards/audit-card/audit-card.component';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './components/navbar/navbar.component';
import { AsidebarComponent } from './components/asidebar/asidebar.component';
import { MenuListComponent } from './components/asidebar/menu-list/menu-list.component';
import {  TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { DeleteModalComponent } from './components/modals/delete-modal/delete-modal.component';
import { DownloadModalComponent } from './components/modals/download-modal/download-modal.component';
import { HygieneCheckFormComponent } from './components/forms/hygiene-check-form/hygiene-check-form.component';
import { NavigationToolbarComponent } from './components/navigation-toolbar/navigation-toolbar.component';
import { InfoAlertComponent } from './components/alerts/info-alert/info-alert.component';
import { InspectionOffcanvasComponent } from './components/offcanvas/inspection-offcanvas/inspection-offcanvas.component';
import { CaptionOffcanvasComponent } from './components/offcanvas/caption-offcanvas/caption-offcanvas.component';
import { ContactOffcanvasComponent } from './components/offcanvas/contact-offcanvas/contact-offcanvas.component';
import { UserOffcanvasComponent } from './components/offcanvas/user-offcanvas/user-offcanvas.component';
import { AppManageOffcanvasComponent } from './components/offcanvas/app-manage-offcanvas/app-manage-offcanvas.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PhBhpContactMenuComponent } from './layout-healthplus/ph-bhp-contact-menu/ph-bhp-contact-menu.component';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TextFieldModule } from '@angular/cdk/text-field';

import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { LanguageDropdownComponent } from './components/ionic-components/language-dropdown/language-dropdown.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PopoverComponent } from './components/popover/popover.component';

import { NgxSummernoteModule } from "ngx-summernote";
import { HtmlTextComponent } from './components/html-text/html-text.component';
import { QuickCommentsOffcanvasComponent } from './components/offcanvas/quick-comments-offcanvas/quick-comments-offcanvas.component';
import { HygieneCheckPageComponent } from './components/pages/hygiene-check-page/hygiene-check-page.component';
import { HygieneplanTabComponent } from './components/pages/hygiene-check-page/hygieneplan-tab/hygieneplan-tab.component';
import { NotesTabComponent } from './components/pages/hygiene-check-page/notes-tab/notes-tab.component';
import { PreviousCheckTabComponent } from './components/pages/hygiene-check-page/previous-check-tab/previous-check-tab.component';
import { ToastComponent } from './components/toast/toast.component';
import { LoginFormComponent } from './components/forms/login-form/login-form.component';
import { LibConfig, LibConfigService } from './config/environment.config';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DateToGermanPipe } from './pipes/dateToGerman';
import { DateCheckFormatterPipe } from './pipes/dateCheckFormatter';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ConfirmDialogComponent } from './components/dialog/confirm-dialog/confirm-dialog.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { FullscreenImageComponent } from './components/modals/fullscreen-image/fullscreen-image.component';
import { EditImageDialogComponent } from './components/dialog/edit-image-dialog/edit-image-dialog.component';
import { CompleteCheckModalComponent } from "./components/modals/complete-check-modal/complete-check-modal.component";
import { InactivityCheckModalComponent } from './components/modals/inactivity-check-modal/inactivity-check-modal.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';

import { CampaignsComponent } from './components/campaigns/campaigns.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { GalleryStationAuditTabComponent } from './components/pages/hygiene-check-page/gallery-station-audit-tab/gallery-station-audit-tab.component';
import { DetailImageFormComponent } from './components/pages/hygiene-check-page/detail-image-form/detail-image-form.component';

export function HttpLoaderFactory(http: HttpClient) {
  const apiUrl = "http://localhost:7000";
  return new TranslateHttpLoader(http, apiUrl + '/api/Translation/', '');
}

@NgModule({
  declarations: [
    ClientLibComponent,
    AuditCardComponent,
    NavbarComponent,
    AsidebarComponent,
    MenuListComponent,
    DeleteModalComponent,
    DownloadModalComponent,
    HygieneCheckFormComponent,
    NavigationToolbarComponent,
    InfoAlertComponent,
    InspectionOffcanvasComponent,
    CaptionOffcanvasComponent,
    ContactOffcanvasComponent,
    UserOffcanvasComponent,
    AppManageOffcanvasComponent,
    PhBhpContactMenuComponent,
    DropdownComponent,
    LanguageDropdownComponent,
    PopoverComponent,
    HtmlTextComponent,
    QuickCommentsOffcanvasComponent,
    HygieneCheckPageComponent,
    HygieneplanTabComponent,
    NotesTabComponent,
    PreviousCheckTabComponent,
    ToastComponent,
    LoginFormComponent,
    DateToGermanPipe,
    DateCheckFormatterPipe,
    SpinnerComponent,
    ConfirmDialogComponent,
    PaginationComponent,
    FullscreenImageComponent,
    EditImageDialogComponent,
    CompleteCheckModalComponent,
    InactivityCheckModalComponent,
    CampaignsComponent,
    GalleryStationAuditTabComponent,
    DetailImageFormComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    DragDropModule,
    TranslateModule.forRoot({
      loader:{
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MatDialogModule,
    MatIconModule,
    RouterModule,
    IonicModule,
    ReactiveFormsModule,
    NgxSummernoteModule,
    BrowserAnimationsModule,
    TextFieldModule,
    CollapseModule,
    FormsModule,
    MatSlideToggleModule
  ],
  exports: [
    ClientLibComponent,
    AuditCardComponent,
    NavbarComponent,
    AsidebarComponent,
    MenuListComponent,
    DeleteModalComponent,
    DownloadModalComponent,
    HygieneCheckFormComponent,
    NavigationToolbarComponent,
    InfoAlertComponent,
    InspectionOffcanvasComponent,
    CaptionOffcanvasComponent,
    ContactOffcanvasComponent,
    UserOffcanvasComponent,
    AppManageOffcanvasComponent,
    PhBhpContactMenuComponent,
    DropdownComponent,
    LanguageDropdownComponent,
    PopoverComponent,
    HtmlTextComponent,
    QuickCommentsOffcanvasComponent,
    HygieneCheckPageComponent,
    HygieneplanTabComponent,
    NotesTabComponent,
    PreviousCheckTabComponent,
    ToastComponent,
    LoginFormComponent,
    DateToGermanPipe,
    DateCheckFormatterPipe,
    SpinnerComponent,
    ConfirmDialogComponent,
    PaginationComponent,
    FullscreenImageComponent,
    EditImageDialogComponent,
    CompleteCheckModalComponent,
    InactivityCheckModalComponent,
    CampaignsComponent,
    GalleryStationAuditTabComponent,
    DetailImageFormComponent
  ],
  providers: [
    ScreenOrientation,
    Storage,
  ]
})
export class ClientLibModule {
  static forRoot(config: LibConfig): ModuleWithProviders<ClientLibModule> {
    return {
      ngModule: ClientLibModule,
      providers: [
        {
          provide: LibConfigService,
          useValue: config
        }
      ]
    }
  }
}
